import { render, staticRenderFns } from "./SliderQuestion.vue?vue&type=template&id=588045b0&scoped=true&"
import script from "./SliderQuestion.vue?vue&type=script&lang=js&"
export * from "./SliderQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SliderQuestion.vue?vue&type=style&index=0&id=588045b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588045b0",
  null
  
)

export default component.exports